
import { Component, Vue, Watch } from "vue-property-decorator";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
// import TableHeaderConfig from "./config";
import { playLayerVioce, FloorVoiceInit } from "@/common/voiceLayer";
import ScanforAcceptPacketShape1 from "./ScanforAcceptPacketShape1.vue";
import ScanforAcceptPacketShape2 from "./ScanforAcceptPacketShape2.vue";
import { LogHelper } from "@/common/LogHelper";
import { ScanforAcceptPacketModule } from "@/store/modules/store_scanforacceptpacket";
import dayjs from "dayjs";
import { DeviceItems2Module } from "@/store/modules/store_deviceitems2";

import {
  checkCode,
  toolsRegularCheckCode,
  checkCodesAndType,
  modeNew,
  abnormalMovingPartDataUpload,
  collectOnly,
  cloudPress,
} from "@/api/service";
import {
  playSuccessSound,
  playFailSound,
  playWantedPackSound,
  NoticeVoiceInit,
} from "@/common/voiceTip";
import {
  ModeAddType,
  ApiQueryType,
  OpCodeEnum,
  UploadStateEnum,
  ModeType,
  ScanSysType,
  SendDataType,
  ReceiveDataType,
  ErrorCode,
} from "@/common/glboalconstant";
import { parseTime } from "@/utils";
import { create } from "domain";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
import { InterceptUtils } from '@/common/intercept-utils';

@Component({
  name: "scanforacceptpacket",
  components: {
    ScanforAcceptPacketShape2,
    ScanforAcceptPacketShape1,
  },
})
export default class extends Vue {
  ///以下功能为测试用
  public test1() {
    try {
      let _package: any = {
        DataType: "2",
        code: this.ytoCode.trim(),
        height: "0.00",
        width: "0.00",
        length: "0.00",
        // weight = textGetWeight.Text,
        mac: this.globalConfig.LocalMac,
      };
      this.setPackageData(_package);
    } catch (error) {
      console.log(error);
    }
  }
  public test2() {
    //测试用
    //给底层发格口信息
    try {
      obj_DWS_Core.hKSocketSynSendDataCallBack(
        SendDataType.PortData,
        "YT3400001856099" + "|" + "01"
      );
    } catch (error) {
      console.log(error);
    }
  }
  public test3() {
    //测试用
    try {
      this.errormessage =
        "调试用，重量结果为:[" + this.GetWeight("").toString() + "]";
    } catch (error) {
      console.log(error);
    }
  }

  get userShape1() {
    return false;
  }

  public globalConfig: any = {};
  public systemConfig: any = {};
  public loginData: any = {};
  public nMode = 0;
  // private config = TableHeaderConfig;
  private statisticalList = [];
  public currentrow = null;
  public showList = [
    // {
    //   index: "100001",
    //   code: "YT1000000000000",
    //   strEmployeeName: "02074485",
    //   strCustomerName: "000001",
    //   strCbxFee: "201901",
    //   strDestOrgName: "柳州航空",
    //   weight: "2.2",
    //   volumnWeight: "5.5",
    //   length: "6",
    //   width: "7",
    //   height: "8",
    //   scanTime: "20210126 00:00:00",
    //   state: "重复扫描",
    //   info: "测试数据"
    // }
  ];
  public ytoCode = "";
  public callbackmodel = {};
  public schemeId = "";
  private bIsRollInit = false; //串口是否打开

  mounted() {
    //初始化统计数据栏目内显示的数据
    this.statisticalList = [
      { label: "总扫描数", value: "0", combine: "1" },
      { label: "车内件数", value: "0", combine: "2" },
      { label: "累计重量", value: "0", combine: "3" },
    ];
    this.globalConfig = SystemConfigModule.globalData;
    this.systemConfig = SystemConfigModule.systemData;
    this.loginData = SystemConfigModule.loginData;

    this.nCurrentMode = this.systemConfig.ModeInfo.ModeAdd_Type;
    this.m_iScanSystem = this.systemConfig.ModeInfo.Mode_Type;
    this.nMode = this.systemConfig.ModeInfo.Mode_Type;
    if (this.nMode > ModeType.ManualScanOutputType) {
      this.nMode = 2;
    }


    //初始化声音分层路径
    FloorVoiceInit();
    NoticeVoiceInit();

    let _data: any = {};
    let _busiData: any = {};
    this.stAcceptPacketReturnData.data = _data;
    this.stAcceptPacketReturnData.data.busiData = _busiData;

    if (null != this.globalConfig.ClientConfigData) {
      for (
        let index = 0;
        index < this.globalConfig.ClientConfigData.length;
        index++
      ) {
        if (
          this.globalConfig.ClientConfigData[index].Key ==
          "maxWeightForCrossBelt"
        ) {
          console.log(this.globalConfig.ClientConfigData[index]);
          this.maxWeightForCrossBelt = Number.parseFloat(
            this.globalConfig.ClientConfigData[index].Value
          );
          this.crossMaxWeight = Number.parseFloat(
            this.globalConfig.ClientConfigData[index].Value
          );
          LogHelper.WriteLog(
            "揽收三段码网关配置允许交叉带最大重量为：" +
              this.maxWeightForCrossBelt.toString()
          );
          break;
        }
      }
    } else {
      LogHelper.Error(
        "this.globalConfig.ClientConfigData为空。获取客户端参数失败"
      );
    }

    try {
      //初始化串口
      this.SerialPortInit();
    } catch (error) {
      console.log("初始化滚筒称串口异常");
      console.log(error);
    }
    //当前设备类型为交叉带时，定时每分钟获取格口方案ID
    // if(this.globalConfig.CurrentDeviceType == 6 || this.globalConfig.CurrentDeviceType == 8)
    // {
    //   this.currentProtocolType = 1;
    //   this.schemeId = obj_GlobalData_Core.getSchemeId();
    //   let  timer = setInterval(()=>{
    //     this.schemeId = obj_GlobalData_Core.getSchemeId();
    //   },60000);
    // }

    try {
      if (typeof obj_DWS_Core !== "undefined") {
        obj_DWS_Core.registerJavaScriptCallback(
          "DWSReceiveDataSetPackageData",
          (value) => {
            LogHelper.WriteLog("DWS传输过来的参数" + value.toString());
            this.ReceiveDataEvent(JSON.parse(value));
          }
        );
      }

      if (typeof obj_CodeReader_Core !== "undefined") {
        obj_CodeReader_Core.registerJavaScriptCallback(
          "CodeReaderSetPackageData",
          (value) => {
            LogHelper.WriteLog(
              dayjs().format("YYYY-MM-DD HH:mm:ss SSS") +
                "得到快手条码:" +
                value
            );
            let data = JSON.parse(value);
            let _package: any = {
              DataType: "2",
              code: data.CodeInfo,
              height: "0.00",
              width: "0.00",
              length: "0.00",
              // weight = textGetWeight.Text,
              mac: this.globalConfig.LocalMac,
            };
            this.setPackageData(_package);
          }
        );
      }

    } catch (error) {
      LogHelper.Error(
        "揽收界面:绑定客户端dws回调函数和快手回调方法执行异常" +
          error.toString()
      );
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
    // this.$nextTick(() => {
    //   this.sendformdata();
    // });
    if (typeof obj_ScanForAcceptPacket !== "undefined") {//判断客户端是否注册揽收core
      try {
        setTimeout(() => {
          if (!this.globalConfig.DeviceStatusValid) {
            this.errormessage = "非圆通有效相机";
          }
          if (!this.globalConfig.MonitorLoginStatus) {
            this.$message.error("OSD连接失败");
          } else {
            this.$message.success("OSD连接成功");
          }

          obj_ScanForAcceptPacket.vueLoaded();//告诉客户端揽收vue界面已经加载完成
        }, 0.5 * 1000);
      } catch (error) {
        LogHelper.Error("揽收功能:判断相机方法执行异常:" + error);
      }
    }
    if (typeof obj_Yto124Targets_Core !== "undefined") {
      try {
        obj_Yto124Targets_Core.yto124TargetsInitDriver();
        LogHelper.WriteLog("揽收功能:obj_Yto124Targets_Core初始化完成");
      } catch (error) {
        LogHelper.Error("揽收功能:obj_Yto124Targets_Core" + error.toString());
      }
    }
  }
  //如果选择了附加项为3 那么就会根据配置初始化串口
  private SerialPortInit() {
    try {
      console.log("当前附加项为：" + this.nCurrentMode.toString());
      if (this.nCurrentMode == 3) {
        try {
          let strBaudRate = this.systemConfig.ModeInfo.RollWeightBaudrate;
          let strDateBits = "8";
          let iBaudRate = Number.parseInt(strBaudRate);
          let iDateBits = Number.parseInt(strDateBits);

          let serialPortOpenFlag = obj_SerialPort_Core.isOpen();
          if (!serialPortOpenFlag) {
            let initResult = obj_SerialPort_Core.init(
              this.systemConfig.ModeInfo.RollWeightCom, //串口号
              iBaudRate, //波特率
              iDateBits, //数据位
              1, //停止位
              0 //校验位
            );
            if (initResult) {
              let openResult = obj_SerialPort_Core.open();
              if (!openResult) {
                // LogHelper.WriteLog("串口打开失败");
                console.log("初始化皮带秤失败！");
              } else {
                //串口打开成功，开始添加定时器，监控传过来的参数
                this.bIsRollInit = true;
                console.log("初始化皮带秤成功！");
              }
            } else {
              console.log("串口初始化失败");
            }
          }

          // spRoll.PortName = this.systemConfig.ModeInfo.RollWeightCom;
          // spRoll.BaudRate = iBaudRate; //波特率
          // spRoll.DataBits = iDateBits; //数据位
          // spRoll.StopBits = StopBits.One; //停止位
          // spRoll.Parity = Parity.None; //校验位
          // spRoll.Open();
          // if (spRoll.IsOpen)
          // {
          //     LogHelper.WriteLog("初始化皮带秤成功！");
          //     this.bIsRollInit = true;
          // }
          // else
          // {
          //     LogHelper.WriteLog("初始化皮带秤失败！");
          // }
        } catch (ex) {
          console.log("初始化皮带秤失败！" + ex);
        }
      }
      //#endregion
    } catch (error) {
      console.log("皮带秤异常" + error);
    }
  }

  private m_bNoNesseryMsg = false; //缺少必要信息
  private m_bNeedSuppleCode = false; //需要补码
  private m_nTemp = 0;
  private nCollectOnlyFailCount = 0; //连续上传失败的次数

  //存储单号跟其优先等级,存储5个
  private codeInterceptioLevel = [];
  private codeCount = 5;
  public m_iScanSystem = -1;

  public crossMaxWeight = 3; //交叉带默认最大重量为3kg
  public maxWeightForCrossBelt = -1;

  // public m_OutBound_GetOff_DataList = [];
  public beforeDestOrgCode = ""; //记录之前的目的网点

  //统计数据
  private dWholeWeight = 0.0;
  private nTotalScanNum = 0;
  private PackageNumInCar = 0;

  private li = 1;
  private nCurrentMode = -1; //当前模式
  private currentGeKou = ""; //当前格口
  private currentDaTouBi = ""; //当前单号的大头笔

  private currentDestOrgCode = ""; //当前单号目的网点
  private latticeOrgCode = ""; //格口网点
  private empCode = ""; //业务员编码
  private currentProtocolType = 0; //当前协议类型，1表示供件协议，0表示正常协议，默认为正常协议

  private m_strValidState = "";
  public stAcceptPacketReturnData: any = {};
  private m_bFirstGet = true;

  // private deviceItems: deviceItem[] = [];

  private inputModel: inputDataModel_AcceptPacket = {
    checked_OverWeightPromot: false,
    checked_NeedWeight: false,
    checked_ExpressContentCode: false,
    checked_InputLength: false,
    checked_InputWidth: false,
    checked_InputHeight: false,
    checked_DestinationOrgNow: false,
    checked_PersonNow: false,
    checked_CustomNow: false,
    checked_PutInWeight: false,
    checked_GetOrderDestnationOrg: true,
    checked_Voice: false,
    input_TakingEffectiveTime: "",
    input_LineFrequencyNo: "",
    input_ExpressContentCode: "包裹",
    input_ExpressContentCodeDisable: false,
    input_Length: "0",
    input_LengthDisable: false,
    input_Width: "0",
    input_WidthDisable: false,
    input_Height: "0",
    input_HeightDisable: false,
    input_ScanCode: "",
    input_CarLabel: "",
    input_TrueThingCode: "",
    input_PanelLine: "",
    input_PanelLineNow: "",
    input_NextOrg: "",
    input_NextOrgNow: "",
    input_DestinationOrg: "",
    input_DestinationOrgNow: "",
    input_Person: "",
    input_PersonNow: "",
    input_Custom: "",
    input_CustomNow: "",
    input_WeighWeight: "0.0",
    input_PutInWeight: "0.0",
    input_VolumeWeight: "0.0",
    input_CustomDisable: false,
    input_DestinationOrgDisable: false,
    input_PutInWeightDisable: false,
  };
  private errormessage = "";

  //DWS调用
  private ReceiveDataEvent(receiveDataEventArgs) {
    switch (receiveDataEventArgs.ReceiveDataType) {
      case ReceiveDataType.CameraState:
        this.SetCameraState(
          JSON.parse(receiveDataEventArgs.JsonData.toString())
        );
        break;
      case ReceiveDataType.PackageData:
        LogHelper.WriteLog("收到底层数据:" + receiveDataEventArgs.JsonData);
        this.setPackageData(
          JSON.parse(receiveDataEventArgs.JsonData.toString())
        );
        break;
      case ReceiveDataType.CodeCheck:
        LogHelper.WriteLog("收到底层数据:" + receiveDataEventArgs.JsonData);
        if (this.CheckMainData()) {
          this.SetCodeCheckNew(
            JSON.parse(receiveDataEventArgs.JsonData.toString())
          );
        }
        break;
      case ReceiveDataType.ErrorState:
        LogHelper.WriteLog(
          "收到底层错误状态码:" + receiveDataEventArgs.JsonData
        );
        this.SetErrorCode(JSON.parse(receiveDataEventArgs.JsonData.toString()));
        break;
      case ReceiveDataType.ErrorInfo:
        LogHelper.WriteLog("收到底层错误信息:" + receiveDataEventArgs.JsonData);
        this.SetErrorInfo(JSON.parse(receiveDataEventArgs.JsonData.toString()));
        break;
    }
  }

  //DWS和快手扫描
  private setPackageData(stPackageData) {
    debugger;
    if (this.nCollectOnlyFailCount >= 5) {
      this.$message.error("揽收数据异常，请重启软件或现场IT !");
      return false;
    }
    LogHelper.WriteLog(
      "揽收功能:" +
        dayjs().format("YYYY-MM-DD HH:mm:ss SSS") +
        "setPackageData:" +
        stPackageData.code
    );
    this.errormessage = "";
    stPackageData.code = stPackageData.code.toUpperCase().trim();
    let rgStr = checkCodesAndType(stPackageData.code.split(), "310");
    let rg = JSON.parse(rgStr);
    if (rg.ResultCode != 200) {
      this.errormessage = rg.Info;
      this.NewAbnormalMovingPartUpload(
        stPackageData.code,
        rg.Info,
        null,
        "100"
      );
      return false;
    }
    if (rg.ResultCode == "200" && rg.Type == ApiQueryType.strCarCode) {
      LogHelper.WriteLog("揽收功能:揽收扫描到车签，过滤");
      return false;
    }

    let tbx_destOrgCode = "";
    if (
      !this.IsNullorEmptyorUndefined(this.inputModel.input_DestinationOrgNow) &&
      this.inputModel.input_DestinationOrgNow.indexOf("|") != -1
    ) {
      tbx_destOrgCode = this.inputModel.input_DestinationOrgNow.split("|")[0];
    }

    try {
      let resultStr = obj_Camera_Core.cameraBLLEnqueueFacade(
        stPackageData.code,
        OpCodeEnum.collect.toString(),
        this.loginData.employeeName,
        tbx_destOrgCode,
        "揽收"
      );
    } catch (error) {
      LogHelper.Error("揽收上传OSD异常:" + error.toString());
    }

    if (!this.CheckMainData()) {
      return false;
    }

    let weight = 0.0;

    LogHelper.WriteLog(
      "重量开关:" + this.globalConfig.WeighConfig.On.toString()
    );
    LogHelper.WriteLog(
      "设备类型:" + this.globalConfig.CurrentDeviceType.toString()
    );
    debugger;
    if (
      this.globalConfig.CurrentDeviceType == 3 &&
      ScanforAcceptPacketModule.putInWeightLock
    ) {
      //如果是狂扫模式，且选中重量锁定
      weight = Number.parseFloat(this.inputModel.input_PutInWeight.toString());
    } else {
      //如果是狂扫模式，且选中重量不锁定以及其他情况
      if (
        this.globalConfig.CurrentDeviceType != 2 &&
        this.globalConfig.CurrentDeviceType != 7
      ) {
        if (this.globalConfig.WeighConfig.On) {
          weight = this.GetWeight(stPackageData.code);
          if (weight <= 0) {
            this.errormessage = "读串口数据异常";
            return false;
          }
        } else {
          try {
            weight = Number.parseFloat(stPackageData.weight);
          } catch (Exception) {
            LogHelper.Error(
              "揽收功能:重量转换失败，重量为：" +
                stPackageData.weight.toString()
            );
            weight = 0;
          }
        }
      } else {
        try {
          weight = Number.parseFloat(stPackageData.weight);
        } catch (ex) {
          LogHelper.Error(
            "揽收功能:重量转换失败，重量为：" + stPackageData.weight.toString()
          );
          weight = 0;
        }
      }
    }

    LogHelper.WriteLog("***获取重量结束" + weight);
    if (weight <= 0) {
      this.errormessage = "当前重量无效：" + weight.toString();
      LogHelper.Error("揽收功能:当前重量无效：" + weight.toString());
      //tbx_scanArea.SelectAll();
      return false;
    }

    this.inputModel.input_ScanCode = stPackageData.code;

    //如果勾选了超重提示，则提示
    if (ScanforAcceptPacketModule.checked_OverWeightPromot) {
      if (weight > this.crossMaxWeight) {
        this.$message.error(
          "重量超过" + this.crossMaxWeight.toString() + "KG无法揽收"
        );
        return false;
      }
    }
    //需要声音分层或者选择交叉带时判断重量
    if (ScanforAcceptPacketModule.checked_Voice || this.nCurrentMode == 1) {
      if (
        -1 != this.maxWeightForCrossBelt &&
        weight > this.maxWeightForCrossBelt
      ) {
        this.errormessage =
          "当前重量" +
          weight +
          "大于" +
          this.maxWeightForCrossBelt.toString() +
          "公斤，禁止上件";
        LogHelper.WriteLog("揽收功能:" + this.errormessage);
        //tbx_scanArea.SelectAll();
        return false;
      }
    }

    //如果时DWS时此处不调用三段码接口
    if (
      this.globalConfig.CurrentDeviceType != 2 &&
      this.globalConfig.CurrentDeviceType != 7 &&
      this.globalConfig.CurrentDeviceType != 8
    ) {
      if (
        !this.SetCodeCheckNew(
          { code: stPackageData.code },
          (Math.floor(weight * 100) / 100).toString()
        )
      ) {
        return false;
      }
    }

    if (
      this.codeInterceptioLevel.some(
        (item) => item.key == stPackageData.code
      ) &&
      this.codeInterceptioLevel.filter(
        (item) => item.key == stPackageData.code
      )[0].value != 1 &&
      this.codeInterceptioLevel.filter(
        (item) => item.key == stPackageData.code
      )[0].value != 2
    ) {
      if (!ScanforAcceptPacketModule.checked_Voice) {
        this.errormessage = "";
      }
      this.codeInterceptioLevel.filter(
        (item) => item.key == stPackageData.code
      )[0].value = 0;
    }

    //为通缉件和目的网点禁止件时不做下车
    if (
      this.m_strValidState == "2" &&
      this.codeInterceptioLevel.some(
        (item) => item.key == stPackageData.code
      ) &&
      this.codeInterceptioLevel.filter(
        (item) => item.key == stPackageData.code
      )[0].value == 1
    ) {
      playFailSound();
      return false;
    }

    //获取stPackageData参数内的长度和重量
    {
      this.inputModel.input_Length = stPackageData.length;
      this.inputModel.input_Width = stPackageData.width;
      this.inputModel.input_Height = stPackageData.height;
      this.inputModel.input_WeighWeight = (
        Math.floor(weight * 100) / 100
      ).toString();
      this.inputModel.input_TrueThingCode = stPackageData.code;
      stPackageData.weight = (Math.floor(weight * 100) / 100).toString();

      //FacadeEnqueue(stPackageData);
      //                 if (check_IsNeedVoice.Checked)
      //                 {
      // Action<Package_Data> a = FacadeEnqueue;
      // a.BeginInvoke(stPackageData, null, null);
      LogHelper.WriteLog(
        dayjs().format("YYYY-MM-DD HH:mm:ss SSS") +
          "揽收功能:揽收上传开始，条码:" +
          stPackageData.code
      );

      //如果是DWS+交叉带模式下，且三段码返回的upload_OPT_FLAG == 1 才上传数据，其余情况不上传
      if (this.globalConfig.CurrentDeviceType == 8) {
        if (
          this.codeInterceptioLevel.some(
            (_code) =>
              _code.key == stPackageData.code &&
              (_code.upload_OPT_FLAG == "1" || _code.upload_OPT_FLAG == "2")
          )
        ) {
          this.FacadeEnqueue(stPackageData);
        } else {
          //upload_OPT_FLAG ==0 或者2 的时候不上传
        }
      } else {
        //非DWS+交叉带情况下
        this.FacadeEnqueue(stPackageData);
      }

      //如果是驱动皮带秤走的大件快手,添加
      if (
        (this.systemConfig.ModeInfo.ModeAdd_Type == ModeAddType.ControlWeight ||
          this.systemConfig.ModeInfo.ModeAdd_Type == 3) &&
        this.bIsRollInit
      ) {
        try {
          //byte[] sendData = {0x08, 0x06, 0x00, 0x02, 0x00, 0x02, 0x01, 0x00, 0xfe, 0x3d, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00 };
          let strCmd = this.systemConfig.ModeInfo.RollCtlCmd;
          // // byte[] sendData = new byte[strCmd.Length];
          // // sendData = strToHexByte(strCmd);
          // // spRoll.Write(sendData, 0, sendData.Length);
          if (this.bIsRollInit) {
            obj_SerialPort_Core.hexWrite(strCmd);
          } else {
            console.log("揽收链接串口失败");
          }
        } catch (ex) {
          console.log("写入串口失败" + ex);
        }
      }

      LogHelper.WriteLog(
        dayjs().format("YYYY-MM-DD HH:mm:ss SSS") +
          "揽收功能:揽收上传结束，条码:" +
          stPackageData.code
      );

      //                 }

      this.inputModel.input_ScanCode = "";
    }

    LogHelper.StatisticsLog("揽收处理结束，条码:" + stPackageData.code);
    LogHelper.WriteLog(
      "揽收功能:揽收处理结束" + dayjs().format("YYYY-MM-DD HH:mm:ss SSS")
    );
    return true;
  }

  private IsInterceptCode(code) {
    var res = JSON.parse(checkCodesAndType(code.split(), "310"));
    if (res.ResultCode != "200") {
      this.errormessage = res.Info;
      //上传异常走件
      this.NewAbnormalMovingPartUpload(code, res.Info, null, "100");
      return true;
    } else {
      return false;
    }
  }

  //DWS SetCodeCheckNew
  private SetCodeCheckNew(codeCheckData, strWeight = "") {
    this.m_nTemp = 0;

    if (this.nCollectOnlyFailCount >= 5) {
      this.$message.error("揽收数据异常，请重启软件或现场IT !");
      return false;
    }
    if (this.IsInterceptCode(codeCheckData.code)) {
      if (
        this.globalConfig.CurrentDeviceType == 5 ||
        this.globalConfig.CurrentDeviceType == 7
      ) {
        obj_DWS_Core.hKSocketSynSendDataCallBack(
          SendDataType.PortData,
          codeCheckData.code + "|" + "153"
        );
        return false;
      }
    }

    if (
      !this.codeInterceptioLevel.some((item) => {
        return item.key == codeCheckData.code;
      })
    ) {
      this.codeInterceptioLevel.unshift({ key: codeCheckData.code, value: 0 });
      if (this.codeInterceptioLevel.length > this.codeCount) {
        let dd = this.codeInterceptioLevel.pop();
        console.log("625");
      }
      // //-----使用以上逻辑替代-----
      // let count = this.codeInterceptioLevel.length - this.codeCount;
      // if (count > 0) {
      //   // let keyList = this.codeInterceptioLevel.Keys.ToList();
      //   for (let index = 0; index < count; index++) {
      //     this.codeInterceptioLevel.pop();
      //   }

      //   let tempDictionary: any = {};
      //   this.codeInterceptioLevel.forEach((item) => {
      //     tempDictionary.push({ key: item.key, value: item.value });
      //   });

      //   this.codeInterceptioLevel = tempDictionary;
      // }
      // //-----结束-----
    } else {
      this.codeInterceptioLevel.filter((item) => {
        return item.key == codeCheckData.code;
      })[0].value = 0;
      // codeInterceptioLevel[codeCheckData.code] = 0;
    }
    debugger;
    try {
      //查询三段码接口
      let strTemp = "";
      let tbx_destOrgCode = "";
      if (
        !this.IsNullorEmptyorUndefined(
          this.inputModel.input_DestinationOrgNow
        ) &&
        this.inputModel.input_DestinationOrgNow.indexOf("|") != -1
      ) {
        tbx_destOrgCode = this.inputModel.input_DestinationOrgNow.split("|")[0];
      }
      //if (!string.IsNullOrEmpty(tbx_destOrgCodeName.Text))
      if (!this.IsNullorEmptyorUndefined(tbx_destOrgCode)) {
        //strTemp = tbx_destOrgCodeName.Text.split('|')[0];
        strTemp = tbx_destOrgCode;
      } else {
        strTemp = "";
      }

      //if (check_IsNeedVoice.Checked)
      if (ScanforAcceptPacketModule.checked_Voice) {
        strTemp += ";1";
      } else {
        strTemp += ";";
      }

      let isReturnPart =
        codeCheckData.code.toUpperCase().startsWith("R02T") ||
        codeCheckData.code.toUpperCase().startsWith("R02Z")
          ? true
          : false;

      let request: any = {};
      request.devMac = this.globalConfig.LocalMac;
      request.devType = this.globalConfig.CurrentDeviceType.toString();
      let body: any = {};
      request.body = body;
      (request.body.autoMode = isReturnPart
        ? this.GetAutoMode().toString()
        : this.nCurrentMode == 0
        ? "3"
        : this.nCurrentMode == 3
        ? "3"
        : "2"),
        (request.body.wayBillNo = codeCheckData.code);
      request.body.mac = this.globalConfig.LocalMacIPv4;
      request.body.extend1 = strWeight;
      request.body.extend2 = "";
      // request.body.extend3 = strTemp;
      // request.body.optFlag = "2"; //1表示下车，2表示揽收
      (request.body.extend3 = isReturnPart
        ? ScanforAcceptPacketModule.checked_Voice
          ? "1"
          : ""
        : strTemp),
        (request.body.optFlag = isReturnPart ? "1" : "2"); //1表示下车，2表示揽收
      (request.body.inOutFlag = this.globalConfig.InOutFlag),
        // var sw = new System.Diagnostics.Stopwatch();
        // sw.Start();
        (this.currentDaTouBi = "");
      this.currentGeKou = "";
      this.currentDestOrgCode = ""; //当前单号目的网点
      this.latticeOrgCode = ""; //格口网点
      this.empCode = "";
      // let dwsQueryResponseNewStr = obj_HttpRequest_Core.modeNew(JSON.stringify(request));
      let dwsQueryResponseNew = modeNew(JSON.stringify(request));
      let isWantedCode = false;
      if (dwsQueryResponseNew.respcode != "000") {
        playFailSound();
        this.errormessage = dwsQueryResponseNew.respMessage;
        LogHelper.WriteLog(
          "【揽收】三段码接口返回失败：" + dwsQueryResponseNew.respMessage
        );
        return false;
      } else {
        debugger;
        //从三段码结果中获取:是否要上传正常轨迹
        //upload_OPT_FLAG :string , 0：不生成  1：生成  2：不是异常三段码
        if (
          this.codeInterceptioLevel.some((_level) => {
            return _level.key == codeCheckData.code;
          })
        ) {
          this.codeInterceptioLevel.filter((_item) => {
            return _item.key == codeCheckData.code;
          })[0].upload_OPT_FLAG = dwsQueryResponseNew.data.upload_OPT_FLAG;
        }

        this.currentDaTouBi = this.IsNullorEmptyorUndefined(
          dwsQueryResponseNew?.data.da_TOU_BI
        )
          ? ""
          : dwsQueryResponseNew?.data.da_TOU_BI;
        this.currentGeKou = this.IsNullorEmptyorUndefined(
          dwsQueryResponseNew?.data.lattice_NO
        )
          ? ""
          : dwsQueryResponseNew?.data.lattice_NO;
        this.empCode = this.IsNullorEmptyorUndefined(
          dwsQueryResponseNew.data?.employee_NO
        )
          ? ""
          : dwsQueryResponseNew.data?.employee_NO;
        this.currentDestOrgCode = this.IsNullorEmptyorUndefined(
          dwsQueryResponseNew.data?.dest_ORG
        )
          ? ""
          : dwsQueryResponseNew.data?.dest_ORG;
        this.latticeOrgCode = this.IsNullorEmptyorUndefined(
          dwsQueryResponseNew.data?.org_CODE
        )
          ? ""
          : dwsQueryResponseNew.data?.org_CODE;
        if (
          !this.IsNullorEmptyorUndefined(dwsQueryResponseNew.data?.da_TOU_BI) &&
          dwsQueryResponseNew.data.da_TOU_BI.startsWith("-")
        ) {
          isWantedCode = true;
          let strInfo = "";
          this.errormessage = InterceptUtils.formatErrorMessage(codeCheckData.code, dwsQueryResponseNew?.data.da_TOU_BI, dwsQueryResponseNew.respMessage);
          strInfo = dwsQueryResponseNew.respMessage;
          //该段代码已经下移
          // if (dwsQueryResponseNew.data?.INTERCEPT_FLAG == "1") {
          //   soundPlayer.SoundLocation = strWantedPackVoice;
          // } else {
          //   soundPlayer.SoundLocation = strOperFailVoice;
          // }

          //不需要生成异常记录，只生成正常记录的
          //if (ExceptionCode.Contains(dwsQueryResponseNew.data?.DA_TOU_BI))
          if (
            dwsQueryResponseNew.data?.upload_OPT_FLAG == "1" &&
            dwsQueryResponseNew.data?.upload_ERROR_FLAG != "1"
          ) {
            this.m_strValidState = "1";
          } else {
            if (dwsQueryResponseNew.data?.upload_ERROR_FLAG == "1") {
              // Task.Run(() => {
              this.$nextTick(() => {
                this.NewAbnormalMovingPartUpload(
                  codeCheckData.code,
                  strInfo,
                  strWeight,
                  dwsQueryResponseNew.data.da_TOU_BI
                );
              });
              // });
            }

            if (
              this.codeInterceptioLevel.some(
                (item) => item.key == codeCheckData.code
              )
            ) {
              this.codeInterceptioLevel.filter(
                (item) => item.key == codeCheckData.code
              )[0].value = 1;
            }
            this.m_strValidState = "2";
            this.m_nTemp = 1;
            try {
              if (dwsQueryResponseNew.data?.intercept_FLAG == "1") {
                // soundPlayer.SoundLocation = strWantedPackVoice;
                playWantedPackSound(dwsQueryResponseNew.data.da_TOU_BI);
              } else {
                playFailSound();
              }
              // soundPlayer.Load();
              // soundPlayer.Play();
            } catch (Exception) {
              // label_scanReturnError.Text = "失败提示音不存在";
            }
          }
        } else {
          this.m_strValidState = "1";
        }
        let bIsDisplsy = false;
        //如果返回声音分层则报声音分层信息
        if (
          !this.IsNullorEmptyorUndefined(
            dwsQueryResponseNew.data.sound_FLOOR_NO
          )
        ) {
          LogHelper.WriteLog(
            "揽收：进入声音分层" + dwsQueryResponseNew.data.sound_FLOOR_NO
          );
          // console.log(
          //   dayjs().format("YYYY-MM-DD HH:mm:ss SSS") + "播放声音开始"
          // );
          this.errormessage = dwsQueryResponseNew.data.sound_FLOOR_NO + "层";
          playLayerVioce(dwsQueryResponseNew.data.sound_FLOOR_NO);
          //VoiceLayerHelper.playSoundFloor(dwsQueryResponseNew.data.sound_FLOOR_NO);

          // console.log(
          //   dayjs().format("YYYY-MM-DD HH:mm:ss SSS") + "播放声音结束"
          // );
          bIsDisplsy = true;
          if (typeof VoiceLayerHelper !== "undefined") {
            VoiceLayerHelper.onPlaySoundFloor(
              dwsQueryResponseNew.data.sound_FLOOR_NO
            );
          }
        }

        if (dwsQueryResponseNew.data.extend1 == "1") {
          if (
            this.IsNullorEmptyorUndefined(dwsQueryResponseNew.data.lattice_NO)
          ) {
            //此单号为无格口的通缉件时优先显示通缉件
            if (
              this.codeInterceptioLevel.some(
                (item) => item.key == codeCheckData.code
              ) &&
              this.codeInterceptioLevel.filter(
                (item) => item.key == codeCheckData.code
              )[0].value != 1 /*m_nTemp != 1*/
            ) {
              this.m_strValidState = "3";
              if (!bIsDisplsy) {
                this.errormessage =
                  "无格口号 " +
                  dwsQueryResponseNew.data.da_TOU_BI +
                  " " +
                  dwsQueryResponseNew.data.waybill_NO;
              }

              // YTO.Automation.Business.ExceptionBLL.QueueException.Enqueue(new ExceptionEntity()
              // {
              //     OpCodeEnum = YTO.Automation.Model.HttpModel.OpCodeEnum.collect,
              //     bussinessType = 1,
              //     devType = this.globalConfig.CurrentDeviceType.toString(),
              //     waybillNo = dwsQueryResponseNew.data.WAYBILL_NO,
              //     unusualCode = "Err_108",
              //     unusualMsg = "无格口号"
              // });
              let result = obj_HttpRequest_Core.queueExceptionEnqueue(
                dwsQueryResponseNew.data.waybill_NO,
                OpCodeEnum.collect,
                1,
                this.globalConfig.CurrentDeviceType.toString(),
                "Err_108",
                "无格口号"
              );
            }
            this.$nextTick(() => {
              // Task.Run(() =>
              // {
              this.NewAbnormalMovingPartUpload(
                codeCheckData.code,
                "无格口号",
                strWeight,
                "100"
              );
              // });
            });
            bIsDisplsy = true;
            LogHelper.WriteLog(this.errormessage);
            dwsQueryResponseNew.data.lattice_NO = "153";
          } else {
            this.currentGeKou = dwsQueryResponseNew.data.lattice_NO;
          }

          if (dwsQueryResponseNew.endTime - dwsQueryResponseNew.startTime <= 400) {
            if (!bIsDisplsy) {
              this.errormessage =
                "格口号：" + dwsQueryResponseNew.data.lattice_NO;
            }
            //给底层发格口信息
            obj_DWS_Core.hKSocketSynSendDataCallBack(
              SendDataType.PortData,
              dwsQueryResponseNew.data.waybill_NO +
                "|" +
                dwsQueryResponseNew.data.lattice_NO
            );
            LogHelper.WriteLog(
              "SendDataType.PortData:" +
                dwsQueryResponseNew.data.waybill_NO +
                "|" +
                dwsQueryResponseNew.data.lattice_NO
            );
            // HKSocket.SynSendDataCallBack(SendDataType.PortData,
            //     dwsQueryResponseNew.data.waybill_NO + "|" + dwsQueryResponseNew.data.lattice_NO);
          } else {
            dwsQueryResponseNew.data.lattice_NO = "0";
            obj_DWS_Core.hKSocketSynSendDataCallBack(
              SendDataType.PortData,
              dwsQueryResponseNew.data.waybill_NO +
                "|" +
                dwsQueryResponseNew.data.lattice_NO
            );
            LogHelper.WriteLog(
              "SendDataType.PortData:" +
                dwsQueryResponseNew.data.waybill_NO +
                "|" +
                dwsQueryResponseNew.data.lattice_NO
            );
            // HKSocket.SynSendDataCallBack(SendDataType.PortData,
            //     dwsQueryResponseNew.data.waybill_NO + "|" + dwsQueryResponseNew.data.lattice_NO);
            LogHelper.WriteLog(
              "三段码网关返回超时(默认400ms)：" +
                (dwsQueryResponseNew.endTime - dwsQueryResponseNew.startTime).toString()
            );
          }
        }
        if (this.m_bNeedSuppleCode) {
          if (
            this.m_strValidState == "1" ||
            (dwsQueryResponseNew.data.extend1 == "1" &&
              this.m_strValidState == "3")
          ) {
            // Sleep(30);
            setTimeout(() => {
              LogHelper.WriteLog(
                "【揽收】需要补码，包裹准入code = " + codeCheckData.code
              );
              obj_DWS_Core.hKSocketSynSendDataCallBack(
                SendDataType.SuppleCode,
                codeCheckData.code
              );
              LogHelper.WriteLog(
                "SendDataType.SuppleCode:" + codeCheckData.code
              );
              // HKSocket.SynSendDataCallBack(SendDataType.SuppleCode, codeCheckData.code);

              this.m_bNeedSuppleCode = false;
            }, 30);

            // // Sleep(100);
          } else {
            return false;
          }
        }

        //自己取格口的时候
        //if (dwsQueryResponseNew.data.EXTEND1 == "1")
        {
          if (this.m_strValidState == "2") {
            LogHelper.WriteLog(
              "【揽收】业务网关取格口，通知海康让plc停  通知代码已注释! and m_strValidState = " +
                this.m_strValidState
            );
          } else if (this.m_strValidState == "1") {
            LogHelper.WriteLog(
              "【揽收】业务网关取格口，通知海康让plc走and m_strValidState = " +
                this.m_strValidState
            );
            obj_DWS_Core.hKSocketSynSendDataCallBack(
              SendDataType.CodeValid,
              this.m_strValidState
            );
            LogHelper.WriteLog(
              "SendDataType.CodeValid:" + this.m_strValidState
            );
          }
        }
        debugger;
        if (this.m_strValidState == "1" || this.m_strValidState == "3") {
          this.stAcceptPacketReturnData.data.busiData.customerId =
            dwsQueryResponseNew.data.customer_NO;
          this.stAcceptPacketReturnData.data.busiData.customerName =
            dwsQueryResponseNew.data.extend2;

          if (
            this.IsNullorEmptyorUndefined(dwsQueryResponseNew.data.employee_NO)
          ) {
            if (
              !this.IsNullorEmptyorUndefined(this.inputModel.input_PersonNow) &&
              this.inputModel.input_PersonNow.indexOf("|") != -1
            ) {
              let input_PersonCodeNameArray =
                this.inputModel.input_PersonNow.split("|");
              this.stAcceptPacketReturnData.data.busiData.employeeId =
                input_PersonCodeNameArray[0];
              this.stAcceptPacketReturnData.data.busiData.employeeName =
                input_PersonCodeNameArray[1];
            } else {
              this.stAcceptPacketReturnData.data.busiData.employeeId = "";
              this.stAcceptPacketReturnData.data.busiData.employeeName = "";
            }
          } else {
            this.stAcceptPacketReturnData.data.busiData.employeeId =
              dwsQueryResponseNew.data.employee_NO;
            this.stAcceptPacketReturnData.data.busiData.employeeName =
              dwsQueryResponseNew.data.extend3;
          }

          if (
            !this.IsNullorEmptyorUndefined(
              this.inputModel.input_DestinationOrgNow
            ) &&
            this.inputModel.input_DestinationOrgNow.indexOf("|") != -1
          ) {
            let strs = this.inputModel.input_DestinationOrgNow.split("|");
            if (strs.length == 2) {
              this.stAcceptPacketReturnData.data.busiData.desOrgCode = strs[0];
              this.stAcceptPacketReturnData.data.busiData.desOrgName = strs[1];
            } else {
              this.stAcceptPacketReturnData.data.busiData.desOrgCode = "";
              this.stAcceptPacketReturnData.data.busiData.desOrgName = "";
            }
          } else {
            this.stAcceptPacketReturnData.data.busiData.desOrgCode =
              dwsQueryResponseNew.data.dest_ORG;
            this.stAcceptPacketReturnData.data.busiData.desOrgName =
              dwsQueryResponseNew.data.dest_CENTER;
          }

          this.stAcceptPacketReturnData.data.busiData.daTouBi =
            dwsQueryResponseNew.data.da_TOU_BI;
          return true;
        } else {
          return false;
        }
      }
    } catch (ex) {
      LogHelper.WriteLog("【揽收】调用三段码接口异常：" + ex.toString());
    }

    return false;
  }

  //DWS设置相机状态
  private SetCameraState(strCameraState) {
    // _deviceItemsCore.SetCameraState(strCameraState);
    let items = this.RefreshState(strCameraState);
    DeviceItems2Module.SetDeviceItemsState(items);

    if (this.m_bFirstGet) {
      //该逻辑判断已经写在winform当中
      // if (HKSocket == null)
      // {
      //     HKSocket = HKSocket.GetHKSocket();
      // }
      this.m_bFirstGet = false;
      //没有句柄传给海康
      // HKSocket.SynSendDataCallBack(SendDataType.handleNumber, CameraPicture.Handle.toString());

      // Thread.Sleep(200);
      // HKSocket.SynSendDataCallBack(SendDataType.Watermark,m_stLoginReturn.orgCode + "|" + m_stLoginReturn.orgName + "|310|揽收");

      //等待200ms后尝试执行
      setTimeout(() => {
        obj_DWS_Core.hKSocketSynSendDataCallBack(
          SendDataType.Watermark,
          this.loginData.orgCode + "|" + this.loginData.orgName + "|310|揽收"
        );
        LogHelper.WriteLog(
          "SendDataType.Watermark:" +
            this.loginData.orgCode +
            "|" +
            this.loginData.orgName +
            "|310|揽收"
        );
      }, 0.2 * 1000);
    }

    return;
  }

  //DWS刷新设备状态信息
  private RefreshState(camera_State) {
    let result = [];
    for (let i = 1; i <= camera_State.cameraState.camList.length; i++) {
      let _info =
        "" +
        "设备" +
        i.toString() +
        "-" +
        "设备状态:" +
        camera_State.cameraState.camList[i - 1].camStatus +
        "-" +
        "设备模式:" +
        this.IsNullorEmptyorUndefined(
          camera_State.cameraState.camList[i - 1].camModel
        )
          ? ""
          : camera_State.cameraState.camList[i - 1].camModel +
            "-" +
            //$"是否有值:是-" +
            "设备Mac:" +
            camera_State.cameraState.camList[i - 1].camMac;

      result.push({
        title: _info,
        name: "设备" + i,
        status:
          camera_State.cameraState.camList[i - 1].camStatus == "1"
            ? "true"
            : "false",
      });
    }

    return result;
  }

  //DWS判断主数据有没有缺失
  private CheckMainData() {
    if (this.inputModel.input_PersonNow == "") {
      try {
        playFailSound();
      } catch (Exception) {
        this.errormessage = "失败提示音不存在";
      }

      this.m_bNoNesseryMsg = true;
      this.errormessage = "收派员不能为空";
      return false;
    } else if (
      this.IsNullorEmptyorUndefined(this.inputModel.input_LineFrequencyNo)
    ) {
      this.errormessage = "频率不能为空";
      return false;
    }

    this.m_bNoNesseryMsg = false;

    return true;
  }

  //DWS设置错误信息
  private SetErrorInfo(stErrorInfo) {
    LogHelper.WriteLog(
      "ScanForAcceptPacket_HKDeviceErrorInfo: " + JSON.stringify(stErrorInfo)
    );
    this.errormessage = stErrorInfo.ErrorString.toString();
  }

  //DWS设置错误代码
  private SetErrorCode(IntErrorCode) {
    if (this.m_bNoNesseryMsg) {
      return false;
    }
    switch (Number.parseInt(IntErrorCode.errorCode)) {
      case ErrorCode.NeedSuppleCode:
        this.errormessage = "需要补码";
        this.m_bNeedSuppleCode = true;
        break;
      case ErrorCode.TooMuchCode:
        this.errormessage = "多条码";
        break;
      case ErrorCode.NoWeight:
        this.errormessage = "无重量";
        break;
      case ErrorCode.OverWeight:
        this.errormessage = "超重";
        break;
      case ErrorCode.NoVolumn:
        this.errormessage = "无体积";
        break;
      case ErrorCode.TooLong:
        this.errormessage = "体积超长";
        break;
      case ErrorCode.NoEntry:
        this.errormessage = "超时，包裹不准入";
        break;
      case ErrorCode.ClearState:
        this.errormessage = "";
        break;
      case ErrorCode.Reset:
        this.errormessage = "";
        this.m_bNeedSuppleCode = false;
        break;
      default:
        break;
    }
    return true;
  }

  //普通扫码
  private ytocodeget(data) {
    debugger;
    this.ytoCode = data.trim();

    let _input_ScanCode = this.ytoCode.toUpperCase().trim();
    // playLayerVioce(_input_ScanCode);
    //VoiceLayerHelper.playSoundFloor(_input_ScanCode);
    // return;
    this.inputModel.input_ScanCode = _input_ScanCode;

    try {
      LogHelper.StatisticsLog("揽收手扫处理开始，条码:" + _input_ScanCode);
      this.errormessage = "";
      if (_input_ScanCode == "") {
        playFailSound();
        this.errormessage = "输入为空";
        return;
      }
      try {
        let bReturnState = true;
        var tbx_destOrgCode = "";
        if (
          !this.IsNullorEmptyorUndefined(
            this.inputModel.input_DestinationOrgNow
          ) &&
          this.inputModel.input_DestinationOrgNow.indexOf("|") != -1
        ) {
          tbx_destOrgCode =
            this.inputModel.input_DestinationOrgNow.split("|")[0];
        }
        try {
          let resultStr = obj_Camera_Core.cameraBLLEnqueueFacade(
            this.inputModel.input_ScanCode,
            OpCodeEnum.collect.toString(),
            this.loginData.employeeName,
            tbx_destOrgCode,
            "揽收"
          );
        } catch (error) {
          LogHelper.Error("揽收上传OSD异常:" + error.toString());
        }

        if (_input_ScanCode.length >= 10) {
          let temps = [];
          temps.push(_input_ScanCode);
          var rg = JSON.parse(checkCodesAndType(temps, "310"));
          if (rg.ResultCode == "200") {
            if (rg.Type == ApiQueryType.strCarCode) {
              this.errormessage = "当前扫到车签";
              return;
            }

            if (
              this.IsNullorEmptyorUndefined(this.inputModel.input_PersonNow)
            ) {
              try {
                playFailSound();
              } catch (Exception) {
                this.errormessage = "失败提示音不存在";
              }

              this.m_bNoNesseryMsg = true;
              this.errormessage = "收派员不能为空";
              return;
            } else if (
              this.IsNullorEmptyorUndefined(
                this.inputModel.input_LineFrequencyNo
              )
            ) {
              this.errormessage = "频率不能为空";
              return;
            }

            if (this.m_bNeedSuppleCode) {
              LogHelper.WriteLog("***************补码");
              this.SetCodeCheckNew({ code: _input_ScanCode });
              this.m_bNeedSuppleCode = false;
              this.inputModel.input_ScanCode = "";
              return;
            }

            if (
              this.m_iScanSystem == ScanSysType.FastHand ||
              this.m_iScanSystem == ScanSysType.ManuScan
            ) {
              //输入重
              let inputWeight = Number.parseFloat(
                this.inputModel.input_PutInWeight.toString()
              );

              let weight = 0.0;
              try {
                weight = this.GetWeight(_input_ScanCode);
              } catch (ex) {
                weight = 0.0;
                LogHelper.WriteLog(
                  "揽收手动扫码取重异常(重量已经重置为0.0):" + ex.toString()
                );
              }
              if (weight <= 0 && inputWeight <= 0) {
                this.errormessage = "称入重/输入重两个中必须有一个值";
                return;
              }
              if (weight <= 0) {
                weight = inputWeight;
              }

              this.inputModel.input_WeighWeight = weight + "";
              //如果勾选了超重提示，则提示
              if (ScanforAcceptPacketModule.checked_OverWeightPromot) {
                if (weight > this.crossMaxWeight) {
                  this.$message.error(
                    "重量超过" + this.crossMaxWeight.toString() + "KG无法揽收"
                  );
                  return;
                }
              }

              LogHelper.WriteLog(
                "输入重：" + this.inputModel.input_WeighWeight
              );
              LogHelper.WriteLog("揽收重量：" + weight.toString());

              if (weight <= 0) {
                this.errormessage = "当前重量无效：" + weight.toString();
                return;
              }

              if (
                !this.SetCodeCheckNew(
                  { code: _input_ScanCode },
                  ((weight * 100) / 100).toString()
                )
              ) {
                return;
              }
            } else if (this.globalConfig.CurrentDeviceType == 3) {
              if (ScanforAcceptPacketModule.putInWeightLock) {
                this.inputModel.input_WeighWeight = Number.parseFloat(
                  this.inputModel.input_PutInWeight.toString()
                ).toString();
              } else {
                //输入重
                let inputWeight = Number.parseFloat(
                  this.inputModel.input_PutInWeight.toString()
                );

                let weight = 0.0;
                try {
                  weight = this.GetWeight(_input_ScanCode);
                } catch (ex) {
                  weight = 0.0;
                  LogHelper.WriteLog(
                    "揽收手动扫码取重异常(重量已经重置为0.0):" + ex.toString()
                  );
                }
                if (weight <= 0 && inputWeight <= 0) {
                  this.errormessage = "称入重/输入重两个中必须有一个值";
                  return;
                }
                if (weight <= 0) {
                  weight = inputWeight;
                }

                this.inputModel.input_WeighWeight = weight + "";
              }
            } else {
              //DWS情况下禁止非补码模式下直接在扫描框输入
              if (
                this.globalConfig.CurrentDeviceType == 2 ||
                this.globalConfig.CurrentDeviceType == 7 ||
                this.globalConfig.CurrentDeviceType == 8
              ) {
                return;
              }
            }
            //如果勾选了超重提示，则提示
            if (ScanforAcceptPacketModule.checked_OverWeightPromot) {
              let _value = 0.0;
              try {
                _value = Number.parseFloat(
                  this.inputModel.input_WeighWeight.toString()
                );
                if (_value > this.crossMaxWeight) {
                  this.$message.error(
                    "重量超过" + this.crossMaxWeight.toString() + "KG无法揽收"
                  );
                  return;
                }
              } catch (error) {
                LogHelper.WriteLog(
                  "揽收手动扫码重量转换失败，条码：" +
                    _input_ScanCode +
                    "重量值:" +
                    this.inputModel.input_WeighWeight
                );
              }
            }

            // 实物条码
            this.inputModel.input_TrueThingCode = _input_ScanCode;
            // this.AutoModeIs23 = false;
            let _package: any = {
              code: _input_ScanCode,
              height: this.inputModel.input_Height,
              length: this.inputModel.input_Length,
              mac: "",
              weight: this.inputModel.input_WeighWeight,
              width: this.inputModel.input_Width,
              DataType: "",
            };
            this.FacadeEnqueue(_package);
            this.inputModel.input_ScanCode = "";
            return;
          } else {
            LogHelper.WriteLog(
              "输入条码非法，条码：" +
                _input_ScanCode +
                "返回条码类型为：" +
                rg.Type
            );
            this.errormessage = rg.Info;
            this.NewAbnormalMovingPartUpload(
              _input_ScanCode,
              rg.Info,
              null,
              "100"
            );
          }
        } else {
          let stCodeCheckInput: any = {};
          let stReturnData: any = {};
          stCodeCheckInput.devMac = this.globalConfig.LocalMac;
          stCodeCheckInput.devType = "0";
          let body: any = {};
          stCodeCheckInput.body = body;
          stCodeCheckInput.body.queryValue = _input_ScanCode;
          stCodeCheckInput.body.queryType = "0";
          stCodeCheckInput.body.viewType = "1";
          stCodeCheckInput.body.extend1 = "";
          stCodeCheckInput.body.extend2 = "";
          stCodeCheckInput.body.extend3 = "";

          let strReturn = "";
          stReturnData = this.CheckCode(stCodeCheckInput);
          this.errormessage = stReturnData.respMessage;

          if (stReturnData.respcode != "000") {
            playFailSound();
            bReturnState = false;
            if (stReturnData.respMessage == null) {
              this.errormessage = "服务器掉线";
              LogHelper.WriteLog("ScanForAcceptPacket" + "服务器掉线");
            } else {
              this.errormessage = stReturnData.respMessage;
              LogHelper.WriteLog("ScanForAcceptPacket" + this.errormessage);
            }
          } else if (
            stReturnData.data.queryNoType == ApiQueryType.strStationCode
          ) {
            //先检查check框
            if (this.inputModel.checked_DestinationOrgNow) {
            } else {
              this.inputModel.input_DestinationOrg = stReturnData.data.queryNo;
              this.beforeDestOrgCode =
                this.inputModel.input_DestinationOrg.toString();
              this.inputModel.input_DestinationOrgNow =
                stReturnData.data.queryNo +
                "|" +
                stReturnData.data.nextOrgCodeName;
              playSuccessSound();
            }
          }
        }
        if (bReturnState) {
          this.inputModel.input_ScanCode = "";
        }
      } catch (error) {
        LogHelper.WriteLog(
          "ScanForAcceptPacket" + "tbx_scanArea_KeyPress crash!" + error
        );
      }
      LogHelper.StatisticsLog("揽收手扫处理结束");
    } catch (error) {
      LogHelper.Error("[错误]:触发界面扫码异常：" + error.message);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }

  //进入队列
  private FacadeEnqueue(stPackageData) {
    LogHelper.WriteLog("start FacadeEnqueue:" + stPackageData.code);
    //获取揽收列表实体
    let package_DataByQueue = this.SetPackageQueueModel(stPackageData);
    debugger;
    //更新汇总信息
    this.dWholeWeight += Number.parseFloat(package_DataByQueue.weight);
    this.nTotalScanNum++;
    this.PackageNumInCar++;
    this.statisticalList[0].value = this.nTotalScanNum.toString();
    this.statisticalList[1].value = this.PackageNumInCar.toString();
    this.statisticalList[2].value = this.dWholeWeight.toString();

    if (!this.inputModel.checked_CustomNow) {
      this.inputModel.input_Custom = "";
      this.inputModel.input_CustomNow = "";
    }
    if (!this.inputModel.checked_DestinationOrgNow) {
      this.inputModel.input_DestinationOrg = "";
      this.inputModel.input_DestinationOrgNow = "";
    }
    if (!this.inputModel.checked_InputLength) {
      this.inputModel.input_Length = "0";
    }
    if (!this.inputModel.checked_InputWidth) {
      this.inputModel.input_Width = "0";
    }
    if (!this.inputModel.checked_InputHeight) {
      this.inputModel.input_Height = "0";
    }

    this.inputModel.input_ScanCode = "";
    this.inputModel.input_WeighWeight = "0";
    if (!ScanforAcceptPacketModule.putInWeightLock) {
      this.inputModel.input_PutInWeight = "0";
    }
    this.inputModel.input_VolumeWeight = "0";

    if (!ScanforAcceptPacketModule.checked_Voice) {
      playSuccessSound();
    }
    try {
      // PassOrder?.Invoke(package_DataByQueue.code, Number.parseFloat(package_DataByQueue.weight));
      obj_JunanService_Core.junanPassOrder(
        package_DataByQueue.code,
        Number.parseFloat(package_DataByQueue.weight)
      );
      //插入界面控件
      let dataHistoryOnForm: any = {};
      dataHistoryOnForm.index = this.li.toString();
      dataHistoryOnForm.code = package_DataByQueue.code
        .toUpperCase()
        .replace("R02T", "")
        .replace("R02Z", "");
      dataHistoryOnForm.strCbxFee = package_DataByQueue.strCbxFee;
      dataHistoryOnForm.strDestOrgName =
        package_DataByQueue.strDestOrgName == null ||
        package_DataByQueue.strDestOrgName.length == 0
          ? ""
          : package_DataByQueue.strDestOrgName;
      dataHistoryOnForm.state = package_DataByQueue.UploadStateName;
      dataHistoryOnForm.weight = package_DataByQueue.weight;
      dataHistoryOnForm.volumnWeight =
        package_DataByQueue.VolumnWeight.toString();
      dataHistoryOnForm.height = package_DataByQueue.height;
      dataHistoryOnForm.length = package_DataByQueue.length;
      dataHistoryOnForm.width = package_DataByQueue.width;
      dataHistoryOnForm.strEmployeeName =
        package_DataByQueue.strEmployeeName == null ||
        package_DataByQueue.strEmployeeName.length == 0
          ? ""
          : package_DataByQueue.strEmployeeName;
      dataHistoryOnForm.strCustomerName =
        package_DataByQueue.strCustomerName == null ||
        package_DataByQueue.strCustomerName.length == 0
          ? ""
          : package_DataByQueue.strCustomerName;
      dataHistoryOnForm.scanTime = dayjs(package_DataByQueue.ScanTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      dataHistoryOnForm.info = package_DataByQueue.Info;

      this.showList.unshift(dataHistoryOnForm);
      this.li++;
      while (this.showList.length > 50) {
        this.showList.pop();
      }

      //大于50个删除最早的那个
    } catch (ex) {
      LogHelper.WriteLog(ex.toString());
    }
    debugger;

    // if (this.globalConfig.CurrentDeviceType == 6 || this.globalConfig.CurrentDeviceType == 8)
    // {
    //   var request = this.GetCrossBeltUploadRequest("NEW",package_DataByQueue.code,package_DataByQueue.weight);
    // }
    // else
    // {
    var request = this.GetDataUploadRequest(package_DataByQueue);
    // }
    debugger;
    let ExpWayBillCheckQueueEntity: any = {
      CallBack: null, //交给C#实现
      Id: null, //交给C#实现
      Request: null,
      WaybillNo: package_DataByQueue.code,
      devType: this.globalConfig.CurrentDeviceType.toString(),
      bIsPackageCode: false,
      latticeNo: this.currentGeKou,
      destOrgCode: "",
      sourceOrgCode: "",
      OpCode: OpCodeEnum.collect,
      daTouBi: this.currentDaTouBi,
      protocolType: this.currentProtocolType,
    };
    //插入队列
    //剩下的入列操作在winform端完成
    obj_HttpRequest_Core.enqueueFacade(
      this.DataUploadCallBack,
      JSON.stringify(request),
      // JSON.stringify(package_DataByQueue),
      JSON.stringify(ExpWayBillCheckQueueEntity)
    );
    //插入队列
    // EnqueueFacade(new ExpWayBillCheckQueueEntity()
    // {
    //     CallBack = DataUploadCallBack,
    //     Request = ,
    //     WaybillNo = package_DataByQueue.code,
    //     devType = Global.GlobalConfig.CurrentDeviceType.toString(),
    //     OpCode = YTO.Automation.Model.HttpModel.OpCodeEnum.collect,
    //     latticeNo = currentGeKou,
    //     daTouBi = currentDaTouBi
    // });
  }

  //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }

  //入列前，生成请求对象
  private SetPackageQueueModel(package_Data) {
    // if (
    //   package_Data.code.toUpperCase().startsWith("R02T") ||
    //   package_Data.code.toUpperCase().startsWith("R02Z")
    // ) {
    //   package_Data.code = package_Data.code
    //     .toUpperCase()
    //     .replace("R02T", "")
    //     .replace("R02Z", "");
    // }
    let datetime = dayjs();
    let strCbxFee = ScanforAcceptPacketModule.QueryTimeTypesList.filter(
      (a) => a.value == this.inputModel.input_TakingEffectiveTime
    )[0].label;
    let DataByQueueAcceptPacket: any = {
      code: package_Data.code,
      weight: package_Data.weight,
      height: package_Data.height,
      length: package_Data.length,
      width: package_Data.width,
      mac: package_Data.mac,
      DataType: package_Data.DataType,
      cbxFee: this.inputModel.input_TakingEffectiveTime,
      strCbxFee: strCbxFee,
      EffectiveTypeCode: this.inputModel.input_LineFrequencyNo,
      PutinWeight: this.inputModel.input_PutInWeight,
      VolumnWeight: Number.parseFloat(
        this.inputModel.input_VolumeWeight.toString()
      ),
      strCustomerName: this.stAcceptPacketReturnData.data.busiData.customerName,
      strCustomerId: this.stAcceptPacketReturnData.data.busiData.customerId,
      strDestOrgName: this.IsNullorEmptyorUndefined(
        this.stAcceptPacketReturnData.data.busiData.desOrgName
      )
        ? this.IsNullorEmptyorUndefined(this.inputModel.input_DestinationOrgNow)
          ? ""
          : this.inputModel.input_DestinationOrgNow.split("|")[1]
        : this.stAcceptPacketReturnData.data.busiData.desOrgName,
      strDestOrgCode: this.IsNullorEmptyorUndefined(
        this.stAcceptPacketReturnData.data.busiData.desOrgCode
      )
        ? this.IsNullorEmptyorUndefined(this.inputModel.input_DestinationOrgNow)
          ? ""
          : this.inputModel.input_DestinationOrgNow.split("|")[0]
        : this.stAcceptPacketReturnData.data.busiData.desOrgCode,
      strEmployeeName: this.stAcceptPacketReturnData.data.busiData.employeeName,
      strEmployeeId: this.stAcceptPacketReturnData.data.busiData.employeeId,
      daTouBi: this.stAcceptPacketReturnData.data.busiData.daTouBi,
      createTime: datetime.valueOf(),
      modifyTime: datetime.valueOf(),
      uploadTime: datetime.valueOf(),
      ScanTime: datetime,
      UploadStateCode: Number.parseInt(UploadStateEnum.NotStarted.toString()),
      UploadStateName: "未上传",
    };

    return DataByQueueAcceptPacket;
  }

  //上传后的返回函数
  private DataUploadCallBack(callbackentityStr) {
    let callBackEntity: any = {};
    try {
      if (this.IsNullorEmptyorUndefined(callbackentityStr)) {
        return;
      }
      callBackEntity = JSON.parse(callbackentityStr);
    } catch (error) {
      LogHelper.Error("[揽收]" + error.toString());
    }
    if (callBackEntity == null || callBackEntity.Response == null) {
      return;
    }

    if (
      callBackEntity.IsSuccess ||
      (callBackEntity.IsSuccess == false &&
        (callBackEntity.extend1 == "2" || callBackEntity.extend1 == "3"))
    ) {
      this.nCollectOnlyFailCount = 0;
    } else {
      this.nCollectOnlyFailCount++;
    }

    var stReturn: any = callBackEntity.Response;

    let strCode = callBackEntity.Request.WaybillNo;
    if (
      strCode.toUpperCase().startsWith("R02T") ||
      strCode.toUpperCase().startsWith("R02Z")
    ) {
      strCode = strCode.toUpperCase().replace("R02T", "").replace("R02Z", "");
    }

    var first = this.showList.filter((f) => f.code == strCode)[0];
    if (first != null) {
      first.state = stReturn?.respcode == "000" ? "已上传" : "上传失败";
      first.info = stReturn?.respMessage;
    } else {
      LogHelper.WriteLog("列表中未找到条码为" + strCode + "的行");
    }
  }

  //生成请求对象
  private GetDataUploadRequest(dequeData) {
    let stAcceptPacketData: any = {};

    try {
      stAcceptPacketData.devMac = this.globalConfig.LocalMac;
      stAcceptPacketData.devType = "0";
      let body: any = {};
      stAcceptPacketData.body = body;

      stAcceptPacketData.body.mac = this.globalConfig.LocalMacIPv4;
      stAcceptPacketData.body.aviType = 0;
      stAcceptPacketData.body.trace = 0;
      stAcceptPacketData.body.isFirstTransfer = 1;
      stAcceptPacketData.body.mty = "0330";
      let opRecord: any = {};
      stAcceptPacketData.body.opRecord = opRecord;
      stAcceptPacketData.body.opRecord.waybillNo = dequeData.code;
      stAcceptPacketData.body.opRecord.createTerminal =
        this.globalConfig.LocalIPv4;
      stAcceptPacketData.body.opRecord.createTime = dequeData.createTime; //(DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000;
      stAcceptPacketData.body.opRecord.desOrgCode = dequeData.strDestOrgCode;
      stAcceptPacketData.body.opRecord.pkgLength = dequeData.length;
      stAcceptPacketData.body.opRecord.pkgHeight = dequeData.height;
      stAcceptPacketData.body.opRecord.pkgWidth = dequeData.width;
      stAcceptPacketData.body.opRecord.weighWeight = dequeData.weight;
      if (
        Number.parseFloat(stAcceptPacketData.body.opRecord.weighWeight) == 0
      ) {
        let _weight = this.GetWeight(dequeData.code);
        if (_weight < 0) {
          stAcceptPacketData.body.opRecord.weighWeight = "0";
        } else {
          stAcceptPacketData.body.opRecord.weighWeight = _weight.toString();
        }
      }
      stAcceptPacketData.body.opRecord.takingCustomerCode =
        dequeData.strCustomerId;
      stAcceptPacketData.body.opRecord.takingEmployeeCode =
        dequeData.strEmployeeId;
      stAcceptPacketData.body.opRecord.takingEffectiveTime = dequeData.cbxFee;
      LogHelper.WriteLog(
        "***timeType" + this.inputModel.input_TakingEffectiveTime
      );

      if (ScanforAcceptPacketModule.checked_Voice && false) {
        stAcceptPacketData.body.opRecord.extend2 = "1";
      } else {
        stAcceptPacketData.body.opRecord.extend2 = "0";
      }

      stAcceptPacketData.body.opRecord.daTouBi = "" /*dequeData.daTouBi*/;
      stAcceptPacketData.body.opRecord.takingCustomerCode =
        dequeData.strCustomerId;
      stAcceptPacketData.body.opRecord.customerName = dequeData.strCustomerName;
      stAcceptPacketData.body.opRecord.takingEmployeeCode =
        dequeData.strEmployeeId;
      stAcceptPacketData.body.opRecord.employeeName = dequeData.strEmployeeName;
      stAcceptPacketData.body.opRecord.frequency = dequeData.EffectiveTypeCode;
      stAcceptPacketData.body.opRecord.extend4 =
        this.loginData.userCode + ";" + this.loginData.userName;
    } catch (ex) {
      LogHelper.WriteLog(
        "ScanForAcceptPacket-GetDataUploadRequest-Exception： " + ex
      );
    }

    return stAcceptPacketData;
  }

  //交叉带供件数据
  private GetCrossBeltUploadRequest(
    opDetail: string,
    wayBillNo: string,
    weight: string
  ) {
    debugger;
    let stAcceptPacketDataForCrossBelt: any = {};
    try {
      let createTime = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
      let signsure = obj_HttpRequest_Core.getSignature("8602", createTime);
      stAcceptPacketDataForCrossBelt.mty = "8602";
      stAcceptPacketDataForCrossBelt.signature = signsure;
      stAcceptPacketDataForCrossBelt.createTime = createTime;
      stAcceptPacketDataForCrossBelt.waybillNo = wayBillNo;
      stAcceptPacketDataForCrossBelt.txId = "codevidion";
      stAcceptPacketDataForCrossBelt.autoDeviceNo = "999";
      stAcceptPacketDataForCrossBelt.createUserCode = this.loginData.userCode;
      stAcceptPacketDataForCrossBelt.schemeId = this.schemeId; //格口方案ID
      stAcceptPacketDataForCrossBelt.mac = this.globalConfig.LocalMac;
      stAcceptPacketDataForCrossBelt.latticeNo = this.currentGeKou;
      stAcceptPacketDataForCrossBelt.destOrgCode = this.currentDestOrgCode; //目的网点，调用三段码接口返回的目的网点
      stAcceptPacketDataForCrossBelt.latticeOrgCode = this.latticeOrgCode; //格口
      stAcceptPacketDataForCrossBelt.containerNo = "";
      stAcceptPacketDataForCrossBelt.weight = weight;
      stAcceptPacketDataForCrossBelt.auxCode = opDetail;
      stAcceptPacketDataForCrossBelt.osdFlag = this.globalConfig
        .MonitorLoginStatus
        ? "1"
        : "0";
      stAcceptPacketDataForCrossBelt.latticeThreeCode = ""; //格口三段码
      stAcceptPacketDataForCrossBelt.daTouBi = this.currentDaTouBi;
      stAcceptPacketDataForCrossBelt.empCode = this.empCode;
      stAcceptPacketDataForCrossBelt.extend1 = "";
      stAcceptPacketDataForCrossBelt.extend2 = "";
      stAcceptPacketDataForCrossBelt.extend3 = "";
    } catch (ex) {
      LogHelper.WriteLog(
        "ScanForAcceptPacket-GetCrossBeltUploadRequest-Exception： " + ex
      );
    }
    return stAcceptPacketDataForCrossBelt;
  }
  //条码规则判断，结合toolsRegularCheckCode和checkCode两个方法
  private CheckCode(stCodeCheckInput) {
    let _resultStr = toolsRegularCheckCode(JSON.stringify(stCodeCheckInput));
    if (_resultStr != null && _resultStr.length > 0) {
      var _result = JSON.parse(_resultStr);
      return _result;
    } else {
      let responseStr = checkCode(JSON.stringify(stCodeCheckInput));
      if (responseStr != null && responseStr.length > 0) {
        var response = JSON.parse(responseStr);
        return response;
      }
    }

    return null;
  }

  //取重方法
  private GetWeight(scanContent) {
    try {
      LogHelper.WriteLog(
        "[揽收]取重开始" + dayjs().format("YYYY-MM-DD HH:mm:ss SSS")
      );
      let weight = obj_Weight_Core.getWeight(scanContent);
      LogHelper.WriteLog(
        "[揽收]取重结束" + dayjs().format("YYYY-MM-DD HH:mm:ss SSS")
      );
      weight = Math.floor(weight * 100) / 100;
      return weight;
    } catch (error) {
      LogHelper.Error(
        "[揽收]取重异常" + dayjs().format("YYYY-MM-DD HH:mm:ss SSS")
      );
      return 0;
    }
  }

  //获取状态
  private GetAutoMode() {
    let tempsystemConfig = this.systemConfig;
    let type = tempsystemConfig.ModeInfo.Mode_Type.toString();

    switch (type) {
      case "1": //快手
        if (tempsystemConfig.ModeInfo.ModeAdd_Type.toString() == "0") return 7;
        return 6;
      case "2": //DWS
      case "5":
      case "6":
      case "7":
        if (tempsystemConfig.ModeInfo.ModeAdd_Type.toString() == "0") return 13;
        return 12;
      case "3": //狂扫
        return 5;
      case "4": //手动
        return 0;
      default:
        return -1;
    }
  }

  //异常走件上传，废弃不用（20220420 modify klm ）
  private AbnormalMovingPartUpload(
    strCode,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null
  ) {
    try {
      var request = this.GetAbnormalMovingPartUploadRequest(
        strCode,
        strInfo,
        strIoTypeName,
        exceptionCode
      );
      let responseStr = abnormalMovingPartDataUpload(JSON.stringify(request));
      let response = JSON.parse(responseStr);
      if (!response.isSuccess) {
        LogHelper.WriteLog("异常走件上传失败" + response.respMessage);
      } else {
        LogHelper.WriteLog("异常走件上传成功" + response.respMessage);
      }
    } catch (ex) {
      LogHelper.WriteLog("异常走件方法调用异常" + ex);
    }
  }

  //新异常走件方法 add by klm 20220420
  private NewAbnormalMovingPartUpload(
    strCode,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null
  ) {
    try {
      let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
      let signsure = obj_HttpRequest_Core.getSignature("8606", datetimeNow);

      let _request = {
        mty: "8606",
        signature: signsure, //登录时需要获取的签名
        createTime: datetimeNow,
        waybillNo: strCode,
        containerNo: null, //容器号,非必填
        deviceType: this.globalConfig.CurrentDeviceType.toString(), //设备类型，必填
        deviceNo: this.globalConfig.LocalIPv4, //大写,用冒号分隔，必填
        errorCode: exceptionCode, //异常码，必填
        errorMsg: strInfo, //异常信息，必填
        opCode: "310", //操作码，非必填
        ioType: null, //收发类型，非必填
        nextOrgCode: "", //下一网点，非必填
        weight: "", //重量，非必填
        createUserCode: this.loginData.userCode,
        extend1: "",
        extend2: "",
        extend3: "",
      };
      let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
      if (stReturnStr?.code == "000") {
        LogHelper.WriteLog("新异常走件方法上传成功");
      } else {
        LogHelper.WriteLog(
          "新异常走件上传失败,返回异常码：" +
            stReturnStr?.code +
            "异常信息：" +
            stReturnStr?.msg
        );
      }
    } catch (ex) {}
  }

  //生成异常走件上传的请求
  private GetAbnormalMovingPartUploadRequest(
    code,
    strInfo,
    strWeight = null,
    DaTouBi = null
  ) {
    var tbx_destOrgCode = "";
    if (
      !(
        this.inputModel.input_DestinationOrgNow == null ||
        this.inputModel.input_DestinationOrgNow.length == 0
      ) &&
      this.inputModel.input_DestinationOrgNow.indexOf("|") != -1
    ) {
      tbx_destOrgCode = this.inputModel.input_DestinationOrgNow.split("|")[0];
    }

    let _request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        containerNo: null,
        effectiveTypeCode: null,
        frequencyNo: null,
        empCode: this.loginData.userCode,
        ioType: null /*dicIoType[cbx_recvType.Text]*/,
        nextOrgCode: tbx_destOrgCode,
        opCode: "310",
        orgCode: this.loginData.orgCode,
        createTime: dayjs().valueOf(),
        previousOrgCode: null /*tbx_previousWebPoint.Text*/,
        waybillNo: code,
        weight: strWeight == null || strWeight.length == 0 ? null : strWeight,
        deviceType: strInfo,
        errorCode: DaTouBi,
        extend1: "",
        extend2: "",
        extend3: "",
      },
    };

    return _request;
  }

  private selectElementContents(el) {
    //失去焦点，获取焦点
    if (el) {
      el.blur();
      el.focus();
    }
  }

  //删除功能
  public deletedatahistory(row) {
    console.log(row);
    if (row == null || row == undefined) {
      return;
    }
    if (row.state == "未上传") {
      this.errormessage = "未上传，不能删除";
      return;
    }

    debugger;
    let code = row.code;
    // if(this.globalConfig.CurrentDeviceType == 6 || this.globalConfig.CurrentDeviceType == 8)
    // {
    //   var nRes = this.DeleteDataForCrossBelt(code);
    // }
    // else
    // {
    var nRes = this.UploadDataFromDgvToServer(code);
    // }
    if (nRes == 0) {
      LogHelper.WriteLog("****btn delete");
      let dataHistoryOnForms = this.showList.filter(
        (obj) => obj.code != code || obj.index != row.index
      );
      this.showList = dataHistoryOnForms;
      this.errormessage = "删除成功！";
      LogHelper.WriteLog(
        "ScanForAcceptPacket_Delete:" + "Barcode " + code + " is Deleted"
      );
      this.nTotalScanNum--;
      if (this.nTotalScanNum < 0) {
        this.nTotalScanNum = 0;
      }
      this.PackageNumInCar--;
      if (this.PackageNumInCar < 0) {
        this.PackageNumInCar = 0;
      }

      this.dWholeWeight -= null == row ? 0 : Number.parseFloat(row.weight);
      if (this.dWholeWeight < 0) {
        this.dWholeWeight = 0;
      }
      this.statisticalList[0].value = this.nTotalScanNum.toString();
      this.statisticalList[1].value = this.PackageNumInCar.toString();
      this.statisticalList[2].value = this.dWholeWeight.toString();
    }
  }

  //删除逻辑
  private UploadDataFromDgvToServer(code) {
    try {
      let stAcceptPacketData: any = {};

      stAcceptPacketData.devMac = this.globalConfig.LocalMac;
      stAcceptPacketData.devType = "0";
      let _body: any = {};
      stAcceptPacketData.body = _body;
      stAcceptPacketData.body.mac = this.globalConfig.LocalMacIPv4;
      stAcceptPacketData.body.aviType = 0;
      stAcceptPacketData.body.trace = 0;
      stAcceptPacketData.body.isFirstTransfer = 1;
      stAcceptPacketData.body.mty = "0330";
      let _opRecord: any = {};
      stAcceptPacketData.body.opRecord = _opRecord;
      stAcceptPacketData.body.opRecord.waybillNo = code;
      stAcceptPacketData.body.opRecord.createTerminal =
        this.globalConfig.LocalIPv4;
      stAcceptPacketData.body.opRecord.createTime = dayjs().valueOf();
      stAcceptPacketData.body.opRecord.desOrgCode =
        this.IsNullorEmptyorUndefined(
          this.stAcceptPacketReturnData.data.busiData.desOrgCode
        )
          ? this.IsNullorEmptyorUndefined(
              this.inputModel.input_DestinationOrgNow
            )
            ? ""
            : this.inputModel.input_DestinationOrgNow.split("|")[0]
          : this.stAcceptPacketReturnData.data.busiData.desOrgCode;
      stAcceptPacketData.body.opRecord.pkgLength = "0.0";
      stAcceptPacketData.body.opRecord.pkgHeight = "0.0";
      stAcceptPacketData.body.opRecord.pkgWidth = "0.0";
      stAcceptPacketData.body.opRecord.weighWeight = "0.0";
      stAcceptPacketData.body.opRecord.takingCustomerCode =
        this.IsNullorEmptyorUndefined(this.inputModel.input_CustomNow)
          ? ""
          : this.inputModel.input_CustomNow.split("|")[0];
      stAcceptPacketData.body.opRecord.takingEmployeeCode =
        this.IsNullorEmptyorUndefined(this.inputModel.input_PersonNow)
          ? ""
          : this.inputModel.input_PersonNow.split("|")[0];
      stAcceptPacketData.body.opRecord.takingEffectiveTime =
        this.inputModel.input_TakingEffectiveTime;

      stAcceptPacketData.body.opRecord.extend1 = "DELETE";

      let stReturnStr = this.AcceptPacket(stAcceptPacketData);
      let stReturn = JSON.parse(stReturnStr);
      if (stReturn.respcode != "000") {
        this.errormessage = stReturn.respMessage;
        if (stReturn.respcode == "101") {
          return 2;
        } else {
          LogHelper.WriteLog("ScanForAcceptPacket：" + stReturn.respMessage);
          return 1;
        }
      }

      return 0;
    } catch (ex) {
      LogHelper.WriteLog(
        "ScanForAcceptPacket" + "UploadDataToServer crash! " + ex
      );
      return 1;
    }
  }

  //供件协议删除接口调用
  private DeleteDataForCrossBelt(code) {
    let nRet = -1;
    try {
      let request = this.GetCrossBeltUploadRequest("DELETE", code, "");
      let stReturnStr = cloudPress(JSON.stringify(request));
      let stReturn = JSON.parse(stReturnStr);
      if (stReturn.code != "000") {
        this.errormessage = stReturn.msg;
        if (stReturn.respcode == "101") {
          return 2;
        } else {
          LogHelper.WriteLog("ScanForAcceptPacket：" + stReturn.msg);
          return 1;
        }
      }

      return 0;
    } catch (ex) {
      return 1;
    }
  }

  //删除请求
  public AcceptPacket(stAcceptPacketData) {
    try {
      let responseStr = collectOnly(JSON.stringify(stAcceptPacketData));
      return responseStr;
    } catch (ex) {
      return "{}";
    }
  }

  //Form1界面回调
  private getFormValue(element) {
    this.inputModel = element;
  }

  //表格控件选中的某一行
  private currentRowChanged(element) {
    this.currentrow = element;
  }
}
